	//document.body.style.backgroundColor = "#12180B";

	var modal_principal = document.querySelector(".alpha-modal");
	var trigger = document.querySelector(".discount-featured-btn");
	var closeButton = document.querySelector(".alpha-close-button");

	function toggleModal() {
	    modal_principal.classList.toggle("alpha-show-modal");
	}

	function windowOnClick(event) {
	    if (event.target === modal_principal) {
	        toggleModal();
	    }
	}

	trigger.addEventListener("click", toggleModal);
	closeButton.addEventListener("click", toggleModal);
	window.addEventListener("click", windowOnClick);

	var modal2 = document.querySelector(".alpha-modal2");
	var trigger2 = document.querySelector(".discount-featured-btn2");
	var closeButton2 = document.querySelector(".alpha-close-button2");

	function toggleModal2() {
	    modal2.classList.toggle("alpha-show-modal2");
	}

	function windowOnClick2(event) {
	    if (event.target2 === modal) {
	        toggleModal2();
	    }
	}

	trigger2.addEventListener("click", toggleModal2);
	closeButton2.addEventListener("click", toggleModal2);
	window.addEventListener("click", windowOnClick2);